export enum StatusCodeGroup {
  Unknown,
  Information,
  Success,
  Redirection,
  ClientError,
  ServerError,
}
